export const PING_INTERVAL = 240000; // 4 minutes. Pharmacist is considered "offline" if being away for more than 5 minutes
